import { LitElement } from 'lit';

/**
 * Check is element is scrolled into view to then reset specific actions/callbacks
 * @param element
 */
export const isScrolledIntoView = (element: LitElement) => {
  const observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting === true) {
        element.dispatchEvent(
          new CustomEvent('scrolled-into-view', { composed: true }),
        );
      }
    },
    { threshold: [0] },
  );
  observer.observe(element);
};

/**
 * When it is possible that the header is sticky we need to add extra margin to the element that is scrolled into view.
 * This function will add the sticky header height to the element that is scrolled in to view to show the complete
 * element in the viewport.
 *
 * @param element {LitElement}
 */
export const scrollStepIntoView = (element: LitElement) => {
  if (element && hasStickyHeaderHeight()) {
    element.style.scrollMarginTop = `${hasStickyHeaderHeight()}px`;
  }
  element.scrollIntoView({ behavior: 'smooth' });
};

/**
 * Check of the main header has the sticky tailwind class, top add a scroll margin top to alway have messages in the
 * viewport. This function wil return the height of the header that can be used in the scroll-margin-top css value.
 *
 * @return number | height of the header element
 */
export const hasStickyHeaderHeight = () => {
  const header = document.querySelector('header');

  if (header && header.classList.contains('sticky')) {
    return header.getBoundingClientRect().height;
  }

  return 0;
};
